import React from 'react';
import {Checkbox ,FormControl,FormGroup,FormControlLabel} from '@material-ui/core'
import {isEmpty, isUndefined} from 'lodash'
function CheckBoxInput(props) {
    const ChangeMstate=(e)=>{
        let Nstate = props.Mstate
       if(isEmpty(props.Mstate.filter(item=>{return props.Meta === item.Meta}))){
            Nstate.push(
                {Meta:props.Meta,Value:0,Checked:e.target.checked}
            )
            props.onChangeMstate(Nstate)
        }
        else{
            let nNstate = Nstate.map(item =>{
            if(item.Meta === props.Meta){
                return {Meta:props.Meta,Value:0,Checked:e.target.checked}
            }else{
                return item
            }
        })
        props.onChangeMstate(nNstate)
        }
        
    }
    return (
        <>
             <FormControl component="fieldset" fullWidth>
                <FormGroup aria-label="position"  row>
                <FormControlLabel
                  
                value={true}                
                control={
                <Checkbox 
                color="primary" 
                disabled={props.disabled} 
                checked={isEmpty(props.Mstate.filter(item=>{return item.Meta === props.Meta}))
                ?false:
                props.Mstate.filter(item=>{return item.Meta === props.Meta})[0].Checked}
                onChange={ChangeMstate}                
                />
                }
                label={props.Meta === 'OrderId'?'Ordernr':props.Meta}
                labelPlacement={"end"}
                />
                </FormGroup>
             </FormControl>
        </>
    );
}

export default CheckBoxInput;